<template>
	<div ref="chart" class="chart-container"></div>
</template>

<script>
	import * as echarts from 'echarts';
	import {
		defineComponent,
		watch,
		reactive,
		toRefs,
		onMounted
	} from "vue"

	export default defineComponent({
		name: "vChart",
		props: {
			option: {
				type: Object,
				default: null
			}
		},
		setup(props) {
			let data = reactive({
				chart: null,
				myChart: null
			})

			let methods = {
				initChart() {
					let container = data.chart
					let myChart = echarts.init(container);
					data.myChart = myChart
					if (props.option) {
						data.myChart.setOption(props.option)
					}
				}
			}

			onMounted(() => {
				methods.initChart()
			})

			watch(props.option, () => {
				if (props.option) {
					data.myChart.setOption(props.option)
				}
			})

			return {
				...toRefs(data),
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.chart-container {
		width: 100%;
		height: 100%;
	}
</style>
